import React, { useState } from "react";
import I18n from "i18next";

import MenuComponent from "commonComponents/Menu/MenuComponent";

const TimeRange = ({ type, disabled, epPortfoliosId, direction, tileName, menuSelect, ...args }) => {
  const [option, setOption] = useState(I18n.t("common.months", { month: 12 }));

  const handleOptionChange = (option) => {
    setOption(option);
    menuSelect(option, tileName);
  };

  return (
    <>
      <MenuComponent
        label={option}
        options={[
          {
            label: I18n.t("common.months", { month: 3 }),
            onClick: () => handleOptionChange(I18n.t("common.months", { month: 3 }))
          },
          {
            label: I18n.t("common.months", { month: 6 }),
            onClick: () => handleOptionChange(I18n.t("common.months", { month: 6 }))
          },
          {
            label: I18n.t("common.months", { month: 12 }),
            onClick: () => handleOptionChange(I18n.t("common.months", { month: 12 }))
          }
        ]}
      />
    </>
  );
};

export default TimeRange;
